import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation Delete($id: Int!) {
    deletePlanAdmissionWay(id: $id) {
      id
    }
  }
`);

export const responseDeleteKey = "deletePlanAdmissionWay";
export interface DeleteGql {
  deletePlanAdmissionWay: {
    id?: number;
  };
}
